export default "/images/framework/WowBarCht.4f72b350.svg?4f72b350";